import React from "react";

export const softSkills = [
  {
    title: "Problem-Solving & Critical Thinking",
    inner: "",
  },
  {
    title: "Requirements Analysis & Technical Planning",
    inner: "",
  },
  {
    title: "Professional / Stakeholder Communication",
    inner: "",
  },
  {
    title: "Ownership & Independent Execution",
    inner: "",
  },
  {
    title: "Cross-Functional Collaboration",
    inner: "",
  },
];

export const hardSkills = [
  {
    title: "Languages & Frameworks",
    inner: (<>
      <h3>Experienced:</h3>
      <ul>
        <li>Angular</li>
        <li>C# / .NET</li>
        <li>JavaScript / jQuery</li>
        <li>HTML / CSS / Bootstrap</li>
        <li>PHP / Laravel</li>
        <li>Swift</li>
        <li>TypeScript</li>
        <li>
          SQL:
          <ul>
            <li>MS SQL Server</li>
            <li>PostgreSQL</li>
            <li>MySQL</li>
          </ul>
        </li>
      </ul>
      <h3>Familiar:</h3>
      <p>
        Working knowledge from prior experience; may require a refresher before regular use.
      </p>
      <ul>
        <li>Bash</li>
        <li>C++</li>
        <li>Django</li>
        <li>GraphQL</li>
        <li>Java</li>
        <li>.NET Framework</li>
        <li>Node.js / Express.js</li>
        <li>Oracle SQL</li>
        <li>PowerShell</li>
        <li>Python</li>
        <li>Racket / LISP</li>
        <li>React / Preact</li>
        <li>SQLite</li>
        <li>Tailwind</li>
      </ul>
    </>)
  },
  {
    title: "Processes & Concepts",
    inner: (<ul>
      <li>Requirements Analysis & Technical Specifications</li>
      <li>Work Breakdown Structures & Development Estimation</li>
      <li>System & Software Architecture</li>
      <li>Performance Optimization</li>
      <li>Relational Database Design, Normalization, & Management</li>
      <li>DevOps & CI/CD</li>
      <li>Agile / Scrum</li>
      <li>REST API Development</li>
      <li>Algorithm Design & Analysis</li>
    </ul>)
  },
  {
    title: "Architecture & Specialized Development",
    inner: (<ul>
      <li>Integration Architecture</li>
      <li>Multi-Tenant Systems</li>
      <li>Single Sign-On & Tenant Switching</li>
      <li>OAuth & JWT Authentication</li>
      <li>AI-Assisted Workflows</li>
      <li>iOS Application Development</li>
      <li>LiDAR Scanning & 3D Data Transformation</li>
      <li>Real-Time Applications & WebSockets</li>
      <li>Automated Data Processing, Visualization, & Reporting</li>
    </ul>)
  },
  {
    title: "Platforms & Tools",
    inner: (<ul>
      <li>Azure Resource Management, Configuration, & Deployments</li>
      <li>Bitbucket & Bitbucket Pipelines</li>
      <li>Visual Studio & VS Code</li>
      <li>Android Studio</li>
      <li>Xcode</li>
      <li>Unity</li>
      <li>Docker / Docker Compose</li>
      <li>Postman</li>
      <li>Git / GitHub</li>
    </ul>)
  },
  {
    title: "APIs & External Platforms",
    inner: (<ul>
      <li>Apple RoomPlan</li>
      <li>ArcGIS / Esri / Survey123</li>
      <li>Google Maps</li>
      <li>Microsoft Graph</li>
      <li>OpenAI</li>
      <li>Stripe</li>
      <li>Twilio</li>
      <li>Twitch</li>
      <li>Verisk / Xactimate</li>
    </ul>)
  }
];
